import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bc6b831")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: [
      'c-button',
      _ctx.getActiveClass,
      _ctx.getAnimationClass,
      _ctx.getSizingClass,
      _ctx.getHalfSize,
      _ctx.getOnlyText,
    ],
    tabindex: "1",
    title: _ctx.buttonLabel,
    onAnimationend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAnimate && _ctx.toggleAnimate(...args))),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleButtonClick && _ctx.handleButtonClick(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
    ], {}, true)
  ], 42, ["title"]))
})